module.exports = __webpack_public_path__ + "img/aff_bg.465681e0.jpeg";